import { useAPIQuery } from "@dev2_techwalnut/tw-api-query-hook";
import { Table } from "@dev2_techwalnut/tw-react-crud-dashlite";
import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import Swal from "sweetalert2";

const columns = [
    {
        accessor: "item",
        header: "Item Name",
        cell: (row) => <>{row?.item?.item_name}</>,
    },
    {
        accessor: "material_type",
        header: "Material Type",
    },
    {
        accessor: "department",
        header: "Department",
        cell: (row) => <>{row?.department?.department_name}</>,
    },
    {
        accessor: "capacity",
        header: "Capacity",
    },
    {
        accessor: "node_id",
        header: "Node ID",
    },
];

const Machine = () => {
    const privileges = secureLocalStorage.getItem("privileges");
    const navigate = useNavigate();
    const [machineEntries, setMachineEntries] = useState(10);
    const [machinePageIndex, setMachinePageIndex] = useState(0);
    const [search, setSearch] = useState("");
    const [globalFilterValue, setGlobalFilterValue] = useState("");
    const [columnFilterKey, setColumnFilterKey] = useState("");
    const [columnFilterValue, setColumnFilterValue] = useState("");

    const { useFetch } = useAPIQuery({
        key: "machine",
        endpoint: "/api/machine/",
    });

    const { data, isLoading, isFetching } = useFetch({
        params: {
            entries: machineEntries,
            page_no: machinePageIndex + 1,
            event: search ? search : undefined,
            q: globalFilterValue !== "" ? globalFilterValue : columnFilterValue,
            c: globalFilterValue === "" ? columnFilterKey : "",
        },
        abortOnNewRequest: true,
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 3,
        retry: 3,
        keepPlaceholder: true,
        refetchOnReconnect: true,
    });

    const { useDelete } = useAPIQuery({
        key: "machine",
        endpoint: "/api/machine/",
    });

    const { mutate: deleteData } = useDelete();

    const handleGlobalFilterChange = (value) => {
        console.log(value);
        setGlobalFilterValue(value);
    };
    const handleColumnFilterChange = (value) => {
        console.log(value);
        setColumnFilterKey(
            value
                .filter((item) => item.value)
                .map((item) => item.id)
                .join(",")
        );
        setColumnFilterValue(
            value
                .filter((item) => item.value)
                .map((item) => item.value)
                .join(",")
        );
    };

    const handlePagination = (value) => {
        console.log(value);
        setMachinePageIndex(value.pageIndex);
        setMachineEntries(value.pageSize);
    };

    const handleEditRow = (row) => {
        console.log(row);
        navigate("/edit-machine", { state: { editpost: row.original } });
    };

    const handleDeleteRow = (row) => {
        console.log(row);
        const entry_id = row.original.id;
        Swal.fire({
            text: "Are you sure? You will not be able to recover this data!",
            showDenyButton: true,
            confirmButtonText: "Yes",
            denyButtonText: `No, cancel!`,
        }).then((result) => {
            if (result.isConfirmed) {
                deleteData({ id: entry_id });
            }
        });
    };

    return (
        <>
            <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                    <div className="nk-block-head-content d-flex">
                        <h3 className="nk-block-title page-title">Machine</h3>
                        {/* {isLoading ? (
                            <div
                                className="spinner-border text-primary ms-2"
                                role="status"
                            >
                                <span className="sr-only"></span>
                            </div>
                        ) : (
                            ""
                        )} */}
                    </div>
                    {privileges.includes("machine_create") && (
                        <div className="nk-block-head-content">
                            <NavLink
                                to="/create-machine"
                                className="toggle btn btn-icon btn-primary d-md-none"
                                id="button-button-create-machine"
                            >
                                <em className="icon ni ni-plus"></em>
                            </NavLink>

                            <NavLink
                                to="/create-machine"
                                className="toggle btn btn-primary d-none d-md-inline-flex"
                                id="button-button-create-machine"
                            >
                                <em className="icon ni ni-plus"></em>
                                <span>Create Machine</span>
                            </NavLink>
                        </div>
                    )}
                </div>
            </div>

            <Table
                data={data ? data?.results.data : []}
                columns={columns}
                pagination
                pageIndex={machinePageIndex}
                pageSize={machineEntries}
                rowCount={data ? data.count : 0}
                isLoading={isLoading || isFetching}
                globalSearch
                editRows={privileges.includes("machine_update") ? true : false}
                deleteRows={
                    privileges.includes("machine_delete") ? true : false
                }
                filterModal={false}
                selectRows={false}
                onGlobalFilterChange={handleGlobalFilterChange}
                onColumnFilterChange={handleColumnFilterChange}
                onRowEdit={handleEditRow}
                onRowDelete={handleDeleteRow}
                onPaginationChange={handlePagination}
            />
        </>
    );
};

export default Machine;
